import { useState, SyntheticEvent, ReactNode } from 'react';
import { AccordionProps as MuiAccordionProps } from '@mui/material/Accordion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '../../library/Typography';
import { renderHTMLString } from '../../../../../helpers';
import {
  StyledAccordion,
  StyledAccordionSummary,
  StyledAccordionDetails,
} from './styles';

export interface AccordionItem
  extends Pick<MuiAccordionProps, 'disabled' | 'expanded' | 'disableGutters'> {
  id?: string;
  title?: string;
  content?: ReactNode;
}
export interface AccordionProps {
  items?: AccordionItem[];
  enableSingleExpand?: boolean;
  defaultSingleExpand?: string;
}

export default function Accordion(props: AccordionProps) {
  const { items = [], enableSingleExpand, defaultSingleExpand = false } = props;

  const [expanded, setExpanded] = useState<string | boolean>(
    defaultSingleExpand,
  );

  const handleChange =
    (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div className="informa-payment-accordion" data-testid="accordion">
      {items.map((accordionItem: AccordionItem, index) => {
        const {
          id,
          title,
          content,
          disabled,
          disableGutters,
          expanded: defaultExpanded,
        } = accordionItem;
        const valueToSetActiveSection = id || title;

        return (
          title &&
          content && (
            <StyledAccordion
              disableGutters={disableGutters}
              disabled={disabled}
              key={`${title}${index}`}
              defaultExpanded={enableSingleExpand ? undefined : defaultExpanded}
              expanded={
                enableSingleExpand
                  ? expanded === valueToSetActiveSection
                  : undefined
              }
              onChange={
                enableSingleExpand && valueToSetActiveSection
                  ? handleChange(valueToSetActiveSection)
                  : undefined
              }
              className="informa-payment-accordion__item"
            >
              <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  variant="h3"
                  neutralColorIndex={700}
                  className="informa-payment-accordion__item-title"
                >
                  {title}
                </Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography
                  variant="body1"
                  component="div"
                  neutralColorIndex={700}
                  className="informa-payment-accordion__item-content"
                >
                  {renderHTMLString(content)}
                </Typography>
              </StyledAccordionDetails>
            </StyledAccordion>
          )
        );
      })}
    </div>
  );
}
